import React, { useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useKioskAuth } from "../../context/KioskAuthContext";

const KioskLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { kioskUser, kioskLogin } = useKioskAuth();

  const [form, setForm] = useState({
    id: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const from = location.state?.from?.pathname || "/kiosk";

  if (kioskUser) {
    return <Navigate to={from} replace />;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting) return;

    setError("");
    setSubmitting(true);

    try {
      const res = await axios.post(
        "/api/kiosk/auth/login_process",
        {
          id: form.id,
          password: form.password,
        },
        {
          withCredentials: true,
        }
      );

      if (res.data && res.data.success) {
        kioskLogin(res.data.user);
        navigate(from, { replace: true });
      } else {
        setError(
          res.data?.message || "아이디 또는 비밀번호가 올바르지 않습니다."
        );
      }
    } catch (err) {
      setError(
        err.response?.data?.message || "로그인 중 오류가 발생했습니다."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>키오스크 로그인</h1>
        <p style={styles.desc}>매장 관리자 계정으로 로그인하세요.</p>

        <form onSubmit={handleSubmit} style={styles.form}>
          <div style={styles.group}>
            <label htmlFor="id" style={styles.label}>아이디</label>
            <input
              id="id"
              name="id"
              type="text"
              value={form.id}
              onChange={handleChange}
              autoComplete="username"
              style={styles.input}
              placeholder="아이디 입력"
            />
          </div>

          <div style={styles.group}>
            <label htmlFor="password" style={styles.label}>비밀번호</label>
            <input
              id="password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
              style={styles.input}
              placeholder="비밀번호 입력"
            />
          </div>

          {error ? <div style={styles.error}>{error}</div> : null}

          <button
            type="submit"
            disabled={submitting}
            style={{
              ...styles.button,
              opacity: submitting ? 0.7 : 1,
              cursor: submitting ? "not-allowed" : "pointer",
            }}
          >
            {submitting ? "로그인 중..." : "로그인"}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f5f5f5",
    padding: "24px",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    background: "#ffffff",
    borderRadius: "12px",
    padding: "32px 24px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
    boxSizing: "border-box",
  },
  title: {
    margin: "0 0 8px",
    fontSize: "28px",
    fontWeight: "700",
    textAlign: "center",
  },
  desc: {
    margin: "0 0 24px",
    fontSize: "14px",
    color: "#666",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  group: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#222",
  },
  input: {
    width: "100%",
    height: "48px",
    border: "1px solid #d9d9d9",
    borderRadius: "8px",
    padding: "0 14px",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box",
  },
  error: {
    fontSize: "14px",
    color: "#d93025",
    background: "#fff2f0",
    border: "1px solid #ffd6d1",
    borderRadius: "8px",
    padding: "12px 14px",
  },
  button: {
    width: "100%",
    height: "48px",
    border: "none",
    borderRadius: "8px",
    background: "#111",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "700",
  },
};

export default KioskLogin;